export const SUMMARY_TABS = {
  GENERAL_INFO: 'GENERAL_INFO',
  DOCUMENTS: 'DOCUMENTS',
  DATA_IMPORT: 'DATA_IMPORT',
  APPLICATIONS: 'APPLICATIONS',
} as const;

export const SUMMARY_TABS_LABELS = {
  GENERAL_INFO: 'Общая информация',
  DOCUMENTS: 'Документы',
  DATA_IMPORT: 'Импорт данных',
  APPLICATIONS: 'Заявки',
} as const;
